const isWindowInExistence = (): boolean => {
  return typeof window !== "undefined"
}

export default isWindowInExistence
